import Icon from "@/plugins/icons";

export default class BooleanHelper {

	public static booleanToIcon(value: boolean): string {
		switch (value) {
			case true:
				return Icon.yes;
			case false:
			default:
				return Icon.no;
		}
	}
}
